import { Container } from '@mui/material';

import Header from '@/components/header/Header';

const Sandbox = () => (
  <Container maxWidth={false}>
    <Header title="Sandbox" />
  </Container>
);

export default Sandbox;
